/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */

import apiService from '@services/apiService';
import { v4 as uuidv4 } from 'uuid';

const ADD_NEW_CLIENT_PHOTO = 'ADD_NEW_CLIENT_PHOTO';
const ADD_FLEXRULE_PHOTOS = 'ADD_FLEXRULE_PHOTOS';
const ADD_API_UPLOAD_RESULT = 'ADD_API_UPLOAD_RESULT';
const ADD_EDIT_PHOTO = 'ADD_EDIT_PHOTO';
const HARD_DELETE_PHOTO = 'HARD_DELETE_PHOTO';
const SET_EDIT_PHOTO = 'SET_EDIT_PHOTO';
const SOFT_DELETE_PHOTO = 'SOFT_DELETE_PHOTO';
const UPDATE_PHOTO_DESCRIPTION = 'UPDATE_PHOTO_DESCRIPTION';
const CLEAR_PHOTO_COLLECTION = 'CLEAR_PHOTO_COLLECTION';
const RESTORE_PHOTO = 'RESTORE_PHOTO';
const REMOVE_EDIT_PHOTO = 'REMOVE_EDIT_PHOTO';
const SET_PHOTO_COLLECTION_SORT_ORDER = 'SET_PHOTO_COLLECTION_SORT_ORDER';

const initialState = {
  photoMetaCollection: [],
  editPhotoMeta: null,
};

const getPhotoMetaObject = () => ({
  key: null,
  id: null,
  originalURL: null,
  srcURL: null,
  cropperSrcURL: null,
  externalURL: null,
  SortOrder: null,
  IsDeleted: null,
  IsUploaded: false,
  IsError: false,
  Description: null,
  thumbailSrcURL: null,
  thumbExternalURL: null,
  cropPointer: null,
  cropperResult: {
    file: null,
    blobURL: null,
  },
  dropZoneMeta: {
    file: null,
    blobURL: null,
  },
  apiMeta: {
    assetType: null,
    displayName: null,
    extension: null,
    isError: null,
    newName: null,
    path: null,
    url: null,
  },
  formikMeta: {
    URL: null,
    SortOrder: null,
    IsDeleted: null,
    IsLive: null,
    IsPreload: null,
    Description: null,
    MediaType: null,
    MediaCategory: null,
  },
  flexMeta: {
    UniqueID: null,
    ParentID: null,
    SortOrder: null,
    IsDeleted: null,
    Description: null,
    MediaCategory: null,
    MediaKeyNumeric: null,
    MediaType: null,
    ModificationTimestamp: null,
    Order: null,
    OriginatingSystemMediaKey: null,
    OriginatingSystemName: null,
    PreferredPhotoYN: null,
    ResourceName: null,
    Path: null,
    URL: null,
    ResourceRecordKeyNumeric: null,
    ModifiedDate: null,
    IsLive: null,
    LongDescription: null,
    ParentType: null,
    OriginatingSystemParent: null,
    IsPreload: null,
    fullSizeURL: null,
    InitialSortOrder: null,
  },
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_NEW_CLIENT_PHOTO: return { ...state, photoMetaCollection: [...state.photoMetaCollection, action.payload] };
    case ADD_FLEXRULE_PHOTOS: return { ...state, photoMetaCollection: [...state?.photoMetaCollection, ...action.payload] };
    case ADD_API_UPLOAD_RESULT: return { ...state, photoMetaCollection: state.photoMetaCollection.map(pmc => ((pmc.key === action.payload.key) ? action.payload : pmc)) };
    case ADD_EDIT_PHOTO: return { ...state, photoMetaCollection: [...state.photoMetaCollection, action.payload] };
    case SET_PHOTO_COLLECTION_SORT_ORDER: return {
      ...state,
      photoMetaCollection: state.photoMetaCollection.map(pmc => {
        const sorted = action.payload.find(sortKV => sortKV.key === pmc.key);
        if (sorted) pmc.SortOrder = sorted.SortOrder;
        return pmc;
      }),
    };
    case SET_EDIT_PHOTO: return { ...state, editPhotoMeta: action.payload };
    case SOFT_DELETE_PHOTO: return { ...state, photoMetaCollection: state.photoMetaCollection.map(pmc => ((pmc.key === action.payload.key) ? action.payload : pmc)) };
    case RESTORE_PHOTO: return { ...state, photoMetaCollection: state.photoMetaCollection.map(pmc => ((pmc.key === action.payload) ? { ...pmc, IsDeleted: false } : pmc)) };
    case REMOVE_EDIT_PHOTO: return { ...state, editPhotoMeta: null };
    case HARD_DELETE_PHOTO: return { ...state, photoMetaCollection: state.photoMetaCollection.map(pmc => ((pmc.key === action.payload.key) ? action.payload : pmc)) };
    case UPDATE_PHOTO_DESCRIPTION: return { ...state, photoMetaCollection: state.photoMetaCollection.map(pmc => ((pmc.key === action.payload.key) ? action.payload : pmc)) };
    case CLEAR_PHOTO_COLLECTION: return { ...initialState };
    default:
      return state;
  }
};

const addNewClientPhoto = newClientPhoto => async dispatch => {
  dispatch({
    type: ADD_NEW_CLIENT_PHOTO,
    payload: { ...newClientPhoto },
  });
};

const addFlexRulePhoto = frPhotos => async dispatch => {
  if (frPhotos?.length) {
    dispatch({
      type: ADD_FLEXRULE_PHOTOS,
      payload: frPhotos,
    });
  } else {
    dispatch({
      type: ADD_FLEXRULE_PHOTOS,
      payload: [frPhotos],
    });
  }
};

const addApiUploadResult = apiResult => async dispatch => {
  dispatch({
    type: ADD_API_UPLOAD_RESULT,
    payload: apiResult,
  });
};

const addEditPhotoResult = (metaSource, cropperBlob) => async dispatch => {
  const originMeta = metaSource;
  const cropMeta = getPhotoMetaObject();
  // const originMeta = photoMeta;
  const newKey = uuidv4(); // create new key to hold original photo;
  cropMeta.key = newKey;
  cropMeta.id = newKey;
  cropMeta.SortOrder = originMeta.SortOrder;
  cropMeta.IsDeleted = originMeta.IsDeleted;
  cropMeta.Description = originMeta.Description;
  cropMeta.cropPointer = originMeta.key; // point to original to use on reset

  originMeta.IsDeleted = true;
  const name = originMeta.Description ?? originMeta.key;
  cropMeta.cropperResult.blobURL = cropperBlob;

  cropMeta.cropperResult.file = await fetch(cropMeta.cropperResult.blobURL).then(r => r.blob()).then(blobFile => new File([blobFile], `${name}.png`, { type: blobFile.type })); // return file from cropperResult
  URL.revokeObjectURL(cropMeta.cropperResult.blobURL); // revoke blob after it has been written to file;
  URL.revokeObjectURL(cropperBlob);
  dispatch({
    type: ADD_EDIT_PHOTO,
    payload: cropMeta,
  });
};

const clearPhotoCollection = () => async dispatch => {
  dispatch({
    type: CLEAR_PHOTO_COLLECTION,

  });
};

const hardDeletePhoto = photoToDelete => async dispatch => {
  dispatch({
    type: HARD_DELETE_PHOTO,
    payload: photoToDelete,
  });
};

const setEditPhoto = (photoToEdit, errorFallback) => async dispatch => {
  const newEditMeta = photoToEdit;
  if (photoToEdit?.externalURL) {
    try {
      const response = await apiService.Photos.getSingleImage(newEditMeta.externalURL);
      newEditMeta.cropperPhoto = response;
    } catch (er) {
      // eslint-disable-next-line no-console
      console.error('Error: Photo setEditPhoto', er);
    }
  } else newEditMeta.cropperPhoto = errorFallback;

  dispatch({
    type: SET_EDIT_PHOTO,
    payload: newEditMeta,
  });
};

const setPhotoCollectionSortOrder = sortedKeys => async dispatch => {
  const sortedKeysPlus1 = sortedKeys.map((key, index) => ({ key, SortOrder: index + 1 }));
  dispatch({
    type: SET_PHOTO_COLLECTION_SORT_ORDER,
    payload: sortedKeysPlus1,
  });
};

const softDeletePhoto = photoToDelete => async dispatch => {
  const deletedPhotoMeta = photoToDelete;
  deletedPhotoMeta.IsDeleted = true;
  dispatch({
    type: SOFT_DELETE_PHOTO,
    payload: deletedPhotoMeta,
  });
};

const removeEditPhoto = () => async dispatch => {
  dispatch({
    type: REMOVE_EDIT_PHOTO,
  });
};

const updatePhotoDescription = photoWithNewDescription => async dispatch => {
  dispatch({
    type: UPDATE_PHOTO_DESCRIPTION,
    payload: photoWithNewDescription,
  });
};

const restorePhotoMetaByKey = photoKey => async dispatch => {
  dispatch({
    type: RESTORE_PHOTO,
    payload: photoKey,
  });
};

export {
  addNewClientPhoto,
  addFlexRulePhoto,
  addEditPhotoResult,
  addApiUploadResult,
  hardDeletePhoto,
  setEditPhoto,
  setPhotoCollectionSortOrder,
  softDeletePhoto,
  removeEditPhoto,
  restorePhotoMetaByKey,
  clearPhotoCollection,
  updatePhotoDescription,
};
